// constant
export const gridSpacing = 3
export const drawerWidth = 260
export const appDrawerWidth = 320
export const maxScroll = 100000
// export const baseURL = process.env.NODE_ENV === 'production' ? window.location.origin : window.location.origin.replace(':8080', ':5000')
// export const baseURL = 'https://arrowagents-apiserver.arrowai.workers.dev'

// src/config.js
// export const baseURL = import.meta.env.MODE === 'development'
//     ? 'http://127.0.0.1:8787'
//     : 'https://arrowagents-apiserver.arrowai.workers.dev';


export const baseURL = 'https://arrowagents-apiserver.arrowai.workers.dev';
export const chatBaseURL = 'https://locahost:8787';
export const chatWebSocketURL = 'wss://locahost:8787/chat/websocket';
// fileURL = https://pub-9f43b88db0544102911ffccf086b1940.r2.dev/


// export const baseURL = 'http://127.0.0.1:8787'
export const uiBaseURL = window.location.origin
export const FLOWISE_CREDENTIAL_ID = 'FLOWISE_CREDENTIAL_ID'
